import { Box } from "@material-ui/core";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { detailChartConfig } from "src/config/constants";
import DetailTokenChart from "./DetailTokenChart";

export default function TokenDetailChart({ historyData, ...props }) {
  return (
    <Box {...props}>
      {detailChartConfig.map((element, index) => {
        return (
          <Box key={index} mb={5}>
            <PaperWrapper title={element["title"]}>
              <DetailTokenChart historyData={historyData} typeList={element["types"]} />
            </PaperWrapper>
          </Box>
        );
      })}
    </Box>
  );
}
